import React from 'react';
import classnames from 'classnames';
import { Col } from 'react-bootstrap';
import SessionSection from '../../SessionSection';
import { AgendaContextConsumer } from '../../AgendaContextProvider';
import SpeakerElement from './SpeakerElement';

export default ({
    session,
    speakers,
    siteConf: {
        color1,
        isWidget
    },
    showCompactLists,
    stickSectionsToLeft
}) => {
    const selectedSpeakers = session?.speakers || [];
    const speakerChildrenClass = classnames('session-page-list', {'session-speaker-compact': showCompactLists});

    const colClass = classnames(
        'padding-left-none margin-bottom-small itemSpeaker',
        {
            'col-lg-12 speaker-preview-session': showCompactLists,
            'col-md-3 col-sm-4': selectedSpeakers.length > 1 && !showCompactLists,
            'col-md-12 col-sm-12': selectedSpeakers.length === 1 && !showCompactLists
        });

    const mostCurrentSpeakers = selectedSpeakers
        .map(({ speakerId, role }) => ({ ...speakers[speakerId], role }))
        .filter(({id}) => typeof id !== 'undefined');

    if (!mostCurrentSpeakers?.length) {
        return null;
    }

    return (
        <SessionSection
            title="Speakers"
            color={color1}
            className="session-speaker-container"
            stickSectionsToLeft={stickSectionsToLeft}
            classChildren={speakerChildrenClass}
        >
            {mostCurrentSpeakers.map(speaker => {
                const { id, speakerId } = speaker;
                return (
                    <Col key={speakerId || id} className={colClass}>
                        <AgendaContextConsumer>
                            {(context) =>
                                <SpeakerElement
                                    speaker={speaker}
                                    sizeImage="large"
                                    classInfo='margin-top-small'
                                    isWidget={isWidget}
                                    context={context}
                                />
                            }
                        </AgendaContextConsumer>
                    </Col>
                );
            })}
        </SessionSection>
    );
};
